import { scrollToEl, addHashToURL, headerOffsetHeight } from './helpers';

/**
 * Scroll to hash on click, and update URL.
 *
 * @since  1.0.0
 */
document.addEventListener('click', (e) => {
    // Only proceed if the target has a hash
    if (e.target.hash) {
        e.preventDefault();
        const { target } = e;
        const { hash, pathname, hostname } = target;
        const { pathname: windowPathname, hostname: windowHostname } = window.location;
        const regex = /^\//;

        // Check if the hash target matches any lightbox content
        const isLightboxTarget = document.querySelector(`.em-lightbox__inner${hash}`) !== null;

        if (isLightboxTarget) {
            // Skip the scroll behavior if the target is a lightbox
            return true;
        }

        // Proceed with the scroll if the hash is not for a lightbox
        if (windowPathname.replace(regex, '') === pathname.replace(regex, '') && windowHostname === hostname) {
            const el = document.querySelector(hash) || document.querySelector(`[name=${hash.slice(1)}]`);
            scrollToEl(el, headerOffsetHeight(el));
            addHashToURL(hash);
            return false;
        }
    }

    return true;
});
